<div class="metrics-dialog">
  <app-modal-header-common title="Add Metrics" [dialogRef]="dialogRef"></app-modal-header-common>

  <div class="metrics-content">
    <form [formGroup]="metricForm" class="two-pane">
      <!-- Left Pane -->
      <div class="pane left-pane">
        <p class="fw-bold mb-2">Available Metrics</p>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Search Metrics</mat-label>
          <input
            matInput
            placeholder="Type to search..."
            [formControl]="metricCtrl"
          />
        </mat-form-field>

        <div class="pane-scroll">
          <mat-chip-list>
            <mat-chip
              *ngFor="let metric of filteredMetrics | async"
              selectable="false"
              removable="false"
              class="metric-chip"
            >
              {{ metric.display_name }}
              <span *ngIf="metric?.metric_unit_name">
                ({{ metric.metric_unit_name }})
              </span>
              <button
                mat-icon-button
                (click)="toggleMetric(metric)"
                class="chip-action add"
              >
                <mat-icon>add</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>

      <div class="pane right-pane">
        <p class="fw-bold mb-2">Selected Metrics</p>

        <div *ngIf="selectedMetrics.length === 0" class="empty-text">
          No metrics selected
        </div>

        <div class="pane-scroll">
          <mat-chip-list>
            <mat-chip
              *ngFor="let metric of selectedMetrics"
              selectable="false"
              removable="false"
              class="metric-chip"
            >
              {{ metric.display_name }}
              <span *ngIf="metric?.metric_unit_name">
                ({{ metric.metric_unit_name }})
              </span>
              <button
                mat-icon-button
                (click)="toggleMetric(metric)"
                class="chip-action remove"
              >
                <mat-icon>remove</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
    </form>
  </div>

  <div class="metrics-footer d-flex justify-content-end">
    <button
      (click)="closeDialog()"
      mat-button
      mat-dialog-close
      color="primary"
      class="mx-1"
    >
      Close
    </button>
    <button
      mat-raised-button
      color="primary"
      class="templ-btn"
      (click)="addMetrics()"
    >
      Save
    </button>
  </div>
</div>
